const MenuItemTakeAway = ({ name }) => {
    let text = 'Takeaway';
    if (name) text += ` (${name})`;

    return text;
};

export default MenuItemTakeAway;
